import { useState, useRef, useEffect } from 'react'
import { useChatStore } from '../stores/chatStore'

export default function MessageInput({ onSend }: { onSend: (text: string) => void }) {
  const [input, setInput] = useState('')
  const streaming = useChatStore((s) => s.streaming)
  const models = useChatStore((s) => s.models)
  const selectedModel = useChatStore((s) => s.selectedModel)
  const setSelectedModel = useChatStore((s) => s.setSelectedModel)
  const textareaRef = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    const ta = textareaRef.current
    if (ta) { ta.style.height = 'auto'; ta.style.height = Math.min(ta.scrollHeight, 160) + 'px' }
  }, [input])

  const handleSubmit = () => {
    const text = input.trim()
    if (!text || streaming) return
    setInput('')
    onSend(text)
  }

  return (
    <div className="px-4 pb-4 pt-2">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-2 mb-2">
          <select value={selectedModel} onChange={(e) => setSelectedModel(e.target.value)}
            className="bg-gray-850 border border-gray-700 text-gray-300 text-xs rounded-lg px-2 py-1 focus:outline-none focus:border-gray-500">
            {models.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
          </select>
          {streaming && <span className="text-xs text-yellow-500 animate-pulse">Streaming...</span>}
        </div>
        <div className="relative">
          <textarea ref={textareaRef} value={input} onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSubmit() } }}
            placeholder="Send a message..." rows={1}
            className="w-full bg-gray-850 border border-gray-700 rounded-xl px-4 py-3 pr-12 text-sm text-white placeholder-gray-500 resize-none focus:outline-none focus:border-gray-500"
            disabled={streaming} />
          <button onClick={handleSubmit} disabled={streaming || !input.trim()}
            className="absolute right-2 bottom-2 p-1.5 rounded-lg bg-white disabled:bg-gray-700 text-black disabled:text-gray-500 transition-colors">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" /></svg>
          </button>
        </div>
      </div>
    </div>
  )
}
